import { Dosage } from 'src/app/opd/dosage/models/dosage';
import { SystemCode } from 'src/app/services/api-service/system-code/system-code';
import { ValueTextPair, ValueTextPairNumberValue } from 'src/app/shared/models/value-text-pair';
import { OPD002Params } from 'src/app/services/api-service/parameters/OPD002Params';
import { HST001Params } from 'src/app/services/api-service/parameters/HST001Params';
import { DosageDTO } from './hist-api';
import { HST002Params } from '../parameters/HST002Params';
import { STK001Params } from '../parameters/STK001Params';
import { CHI001Params } from '../parameters/CHI001Params';

export declare type DxOpt = {
  Code: string;
  ApplyCode: string;
  Short: string;
  ShortNo: string;
  CName: string;
  EName: string;
  ICD9: string;
  SpecItem?: string;
  AcuteNote?: number;
  StartDate?: Date;
  EndDate?: Date;
}
// export declare type RxOpt = {
export class RxOpt {
  Id: number;
  RxCode: string;
  StdCode: string;
  Type: number;
  ProdName: string;
  IsByOral: boolean;
  MainSetId: number;
  RsCode: string;
  SPRule: number;
  CTRDrugs: string;
  IPrice: number;
  Price: number;
  IsDrugStatus: boolean;
  IsAlternative: boolean;
  DrugStopDate: Date;
  AlternativeRxId?: number;
  PaymentType?: string;
  FlagDescription?: string;
  Surs?: string;
  SPTXs?: string;
  Way?: string;
  Tot?: number;
  ToothPos?: string;
  StartTreatDate?: Date;
  IIName: string;
  GXName: string;
  ImportantTip?: string;
  ShortNo: string;
  UseUnit?: string;
  DefaultAutoDisp?: string = null;
  EndDate?: Date = null;
  IsRxSet?: boolean = null;
}
// export declare type RsOpt = {
export class RsOpt {
  RxSetId: number;
  MainSetId: number;
  RxId: number;
  RxCode: string;
  StdCode: string;
  ProdName: string;
  RsCode: string;
  AlternativeRxId?: number;
  Surs: string;
  SPTXs: string;
}
export declare type statDetail = {
  Month: string[],
  Season: string[],
  Week: string[]
}
export declare type userStat = {
  ClinicStat: statDetail,
  UserStat: statDetail
}
export class HistEditOption {
  cc: SystemCode[];
  pe: SystemCode[];
  // statDx: userStat;
  // statRx: userStat;
  // statCC: userStat;
  // statPE: userStat;
  dosage: DosageDTO[];
  way: SystemCode[];
  part: SystemCode[];
  chiPart: SystemCode[];
  chiProcess: SystemCode[];
  chiForm: SystemCode[];
  dispensing: ValueTextPair[];
  remarks: ValueTextPair[];      // 醫令備註選項 磨粉 (Oral)
  hrxRemarks: ValueTextPair[];   //醫令備註選項 其他 (Hrx_Remark)
  defaultSelfDispensing: string;
  histParams: HST001Params;
  hist2Params: HST002Params;
  opdParams: OPD002Params;
  stkParams: STK001Params;
  chiParams: CHI001Params;
  // pharmarcist : ValueTextPairNumberValue[]; 暫無用到
  /** 預設調劑方式 */
  //defaultSelfDispensing: string;
  isShowPricingWindow: boolean;

  // 磨粉年齡
  p253: string;
  // 醫令新增預設劑量模式
  p255: string;
  // 門診預設Focus區域
  p15: string;
  // 交付慢箋加印張數
  p37: string;
  // 有無排班表
  p289: string;
  // 進位規則
  p135: string;
  // 體重/年齡對應劑量
  p79: string;
  isAlertPaid: boolean;

  doctor: ValueTextPairNumberValue[];
  executor?: ValueTextPair[];
  sex?: ValueTextPairNumberValue[] = [];
}
